module.exports = __webpack_public_path__ + "img/LOGO_UBRUlib_Orange_noom_cap.dcca1265.png";